import { v4 as uuidv4 } from "uuid";
import { FieldProps, GroupProps } from "../../utils/functionsInterfaces";
import { displayError, displayInfo } from "../../utils/messageToast";

export const handleAddPersonalDetailField = (
  groupId: string,
  expandedGroups: string[],
  form: GroupProps[],
  setForm: React.Dispatch<React.SetStateAction<GroupProps[]>>,
  fieldAdd: string,
  setAddFieldPersonalDetails: React.Dispatch<React.SetStateAction<string>>,
  setButtonSave: React.Dispatch<React.SetStateAction<boolean>>
) => {
  expandedGroups.push(groupId as string);

  let newFieldPersonalDetail: FieldProps;

  const findFieldInForm = (
    form: (GroupProps | FieldProps)[],
    fieldAdd: string
  ): boolean => {
    return form.some((item: GroupProps | FieldProps) => {
      if ("children" in item) {
        if (item.children && findFieldInForm(item.children, fieldAdd)) {
          return true;
        }
      } else if (item.id === fieldAdd) {
        return true;
      }
      return false;
    });
  };
  const fieldExists = findFieldInForm(form, fieldAdd);

  if (fieldExists) {
    displayError("Campo já existe!");
    setAddFieldPersonalDetails("");
    return;
  }

  if (fieldAdd === "customerSocialNumber") {
    newFieldPersonalDetail = {
      uuid: uuidv4(),
      id: "customerSocialNumber",
      name: "CPF do cliente",
      type: "field",
      isNew: true,
      attribute: "",
      settings: {
        detail: "customerSocialNumber",
        placeholder: "Insira o CPF do cliente",
      },
      fieldType: "personal_details",
    };
    setButtonSave(true);
    displayInfo("Campo de documento criado!");
  } else if (fieldAdd === "customerPhoneNumber") {
    newFieldPersonalDetail = {
      uuid: uuidv4(),
      id: "customerPhoneNumber",
      name: "Telefone do cliente",
      type: "field",
      isNew: true,
      attribute: "",
      settings: {
        detail: "customerPhoneNumber",
        placeholder: "Insira o telefone do cliente.",
      },
      fieldType: "personal_details",
    };
    setButtonSave(true);
    displayInfo("Campo de telefone criado!");
  } else if (fieldAdd === "customerEmail") {
    newFieldPersonalDetail = {
      uuid: uuidv4(),
      id: "customerEmail",
      name: "Email",
      type: "field",
      isNew: true,
      attribute: "",
      settings: {
        detail: "customerEmail",
        placeholder: "Insira seu Email",
        autofillParam: "mail",
      },
      fieldType: "personal_details",
    };
    setButtonSave(true);
    displayInfo("Campo de email criado!");
  } else {
    newFieldPersonalDetail = {
      uuid: uuidv4(),
      id: "customerName",
      name: "Nome do cliente",
      type: "field",
      isNew: true,
      attribute: "",
      settings: {
        detail: "customerName",
        placeholder: "Insira o Nome do cliente",
      },
      fieldType: "personal_details",
    };
    setButtonSave(true);
    displayInfo("Campo de nome criado!");
  }

  setAddFieldPersonalDetails("");

  const findGroupAndAddField = (
    groups: (GroupProps | FieldProps)[]
  ): boolean => {
    for (const group of groups) {
      if ("children" in group) {
        if (group.id === groupId) {
          if (group.children) {
            group.children.push(newFieldPersonalDetail);
          } else {
            group.children = [newFieldPersonalDetail];
          }
          return true;
        }
        if (findGroupAndAddField(group.children ?? [])) {
          return true;
        }
      }
    }
    return false;
  };

  const newForm = [...form];
  if (findGroupAndAddField(newForm)) {
    setForm(newForm);
  } else {
    displayError("Grupo não encontrado!");
  }
};
